// src/Components/BottomBar/BottomBar.tsx
import './BottomBar.css';
import { Home, Menu, User, ShoppingBag, Bell } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router';
import { useProductContext } from '../../Context/ProductContext';
import { useCartCount } from '../../stores/cartStore';
import { useNotifications } from '../../hooks/useNotifications';

const BottomBar = () => {
  const { setDrawbarActive, DrawbarActive } = useProductContext();
  const cartCount = useCartCount();
  const { unreadCount } = useNotifications();
  const NavigateTo = useNavigate();
  const location = useLocation();

  const isHome    = location.pathname === '/Home';
  const isProfil  = location.pathname.startsWith('/Profile/Account');
  const isBasket  = location.pathname.startsWith('/Profile/Basket');
  const isNotifs  = location.pathname.startsWith('/Notifications');
  const isMenu    = DrawbarActive;

  const handleNavigate = (path: string) => {
    setDrawbarActive(false);
    NavigateTo(path);
  };

  const handleMenu = () => setDrawbarActive((prev) => !prev);

  // La garde de /Profile/Account renvoie vers l'OTP si besoin, en mémorisant
  // la destination : après vérification on arrive bien sur le compte.
  const handleProfil = () => {
    setDrawbarActive(false);
    NavigateTo('/Profile/Account');
  };

  // Panier accessible sans compte : il vit dans le navigateur et l'OTP
  // n'intervient qu'au bouton « Commander ».
  const handleBasket = () => {
    setDrawbarActive(false);
    NavigateTo('/Profile/Basket');
  };

  const handleNotifs = () => {
    setDrawbarActive(false);
    NavigateTo('/Notifications');
  };

  return (
    <div id="BottomBarContainer">
      <nav id="BottomBar">
        <button
          className={`nav-btn ${isHome && !DrawbarActive ? 'active' : ''}`}
          onClick={() => handleNavigate('/Home')}
          aria-label="Accueil"
        >
          <Home size={22} strokeWidth={1.5} />
          <span className="nav-label">Accueil</span>
        </button>
        <button
          className={`nav-btn ${isMenu ? 'active' : ''}`}
          onClick={handleMenu}
          aria-label="Menu"
        >
          <Menu size={22} strokeWidth={1.5} />
          <span className="nav-label">Menu</span>
        </button>
        <button
          className={`nav-btn ${isProfil && !DrawbarActive ? 'active' : ''}`}
          onClick={handleProfil}
          aria-label="Profil"
        >
          <User size={22} strokeWidth={1.5} />
          <span className="nav-label">Profil</span>
        </button>
        <button
          className={`nav-btn ${isBasket && !DrawbarActive ? 'active' : ''}`}
          onClick={handleBasket}
          aria-label={`Panier (${cartCount} articles)`}
        >
          <span className="icon-wrapper">
            <ShoppingBag size={22} strokeWidth={1.5} />
            {cartCount > 0 && (
              <span className="cart-badge" aria-label={`${cartCount} articles`}>
                {cartCount > 9 ? '9+' : cartCount}
              </span>
            )}
          </span>
          <span className="nav-label">Panier</span>
        </button>
        <button
          className={`nav-btn ${isNotifs && !DrawbarActive ? 'active' : ''}`}
          onClick={handleNotifs}
          aria-label={`Notifications (${unreadCount} non lues)`}
        >
          <span className="icon-wrapper">
            <Bell size={22} strokeWidth={1.5} />
            {unreadCount > 0 && (
              <span className="cart-badge" aria-label={`${unreadCount} non lues`}>
                {unreadCount > 9 ? '9+' : unreadCount}
              </span>
            )}
          </span>
          <span className="nav-label">Alertes</span>
        </button>
      </nav>
    </div>
  );
};

export default BottomBar;